import { render, staticRenderFns } from "./PageHelp.yaml?vue&type=template&id=46377a54&component"
import script from "./PageHelp.yaml?vue&type=script&lang=ts&component"
export * from "./PageHelp.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports